<template>
  <div class="section-title">
    <span class="wing">✦</span>
    <span class="bold">Social Media</span>
    <span class="wing">✦</span>
  </div>

  <div class="grid-wrapper">
    <a
      v-for="(item, i) in socials"
      :key="i"
      :href="item.url"
      target="_blank"
      style="text-decoration: none;"
    >
      <div class="card-wrapper" v-tilt3d>
        <div class="card">
          <ProductCard
            :title="item.title"
            :description="item.description"
            :price="item.price"
            :image="item.image"
            :label="item.label"
          />
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import tiktok from './../assets/Tiktok.png'
import youtube from './../assets/Youtube.png'
import instagram from './../assets/Instagram.png'
import twitter from './../assets/Twitter.png'

import ProductCard from './ProductCard.vue'

export default {
  name: "SocialsGrid",
  components: { ProductCard },

  directives: {
    tilt3d: {
      mounted(el) {
        const card = el.querySelector(".card");
        const avatarImg = el.querySelector(".product-img") || el.querySelector("img");
        if (!card || !avatarImg) return;

        const maxRotate = 14;
        const maxTranslate = 16;
        const maxPinch = 10;

        function resetCard() {
          card.style.transform = "rotateX(0deg) rotateY(0deg)";
          card.style.boxShadow =
            "0 18px 40px rgba(15,23,42,0.8), 0 0 0 1px rgba(148,163,184,0.2)";
          avatarImg.style.transform = "translateZ(40px) translateX(0) translateY(0)";
          avatarImg.style.animationPlayState = "running";
        }

        const onMove = (e) => {
          const rect = card.getBoundingClientRect();
          const x = (e.clientX ?? e.touches?.[0]?.clientX) - rect.left;
          const y = (e.clientY ?? e.touches?.[0]?.clientY) - rect.top;

          const percentX = (x / rect.width) - 0.5;
          const percentY = (y / rect.height) - 0.5;

          const rotateY = percentX * (maxRotate * 2);
          const rotateX = -percentY * (maxRotate * 2);

          const translateX = percentX * (maxTranslate * 2);
          const translateY = percentY * (maxTranslate * 2);
          const pinchZ = maxPinch + Math.abs(percentX) * maxPinch;

          card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

          card.style.boxShadow = `
            ${-percentX * 30}px ${18 + percentY * 20}px 50px rgba(15,23,42,0.95),
            0 0 0 1px rgba(148,163,184,0.35)
          `;

          avatarImg.style.animationPlayState = "paused";
          avatarImg.style.transform = `
            translateZ(${40 + pinchZ}px)
            translateX(${translateX}px)
            translateY(${translateY}px)
          `;
        };

        const onEnter = () => {
          avatarImg.style.animationPlayState = "paused";
        };

        const onLeave = () => {
          resetCard();
        };

        card.addEventListener("mousemove", onMove);
        card.addEventListener("mouseenter", onEnter);
        card.addEventListener("mouseleave", onLeave);

        card.addEventListener("touchstart", (ev) => {
          onMove(ev.touches ? ev.touches[0] : ev);
        }, { passive: true });

        card.addEventListener("touchmove", (ev) => {
          onMove(ev.touches ? ev.touches[0] : ev);
        }, { passive: true });

        card.addEventListener("touchend", onLeave, { passive: true });

        el._tiltCleanup = () => {
          card.removeEventListener("mousemove", onMove);
          card.removeEventListener("mouseenter", onEnter);
          card.removeEventListener("mouseleave", onLeave);
          card.removeEventListener("touchstart", onMove);
          card.removeEventListener("touchmove", onMove);
          card.removeEventListener("touchend", onLeave);
        };
      },
      unmounted(el) {
        if (el._tiltCleanup) el._tiltCleanup();
      }
    }
  },

  data() {
    return {
      socials: [
        {
          title: "TikTok",
          description: "@kasekiru",
          price: "Random Unique Post",
          image: tiktok,
          label: "Tiktok",
          url: "https://tiktok.com/@kasekiru"
        },
        {
          title: "YouTube",
          description: "@kasekiru",
          price: "Weird Animation Post",
          image: youtube,
          label: "YouTube",
          url: "https://youtube.com/@kasekiru"
        },
        {
          title: "Instagram",
          description: "@kasekiru",
          price: "Don't Know Yet",
          image: instagram,
          label: "Instagram",
          url: "https://instagram.com/kasekiru"
        },
        {
          title: "Twitter (X)",
          description: "@kasekiru",
          price: "Don't Know Yet",
          image: twitter,
          label: "Twitter",
          url: "https://x.com/kasekiru"
        }
      ]
    };
  }
};
</script>

<style scoped>
.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin-bottom: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

.section-title .wing {
  opacity: 0.85;
  font-size: 18px;
}

/* grid */
.grid-wrapper {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: center;
  padding-bottom: 40px;
}

.card-wrapper {
  perspective: 1200px;
}

/* =============================
   TRUE GLASSMORPHISM CARD
============================= */
.card {
  position: relative;
  width: 260px;
  height: 260px;
  border-radius: 22px;
  padding: 14px;

  /* GLASS BASE */
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);

  /* Glass Border */
  border: 1.6px solid rgba(255, 255, 255, 0.22);

  /* Stronger Depth Shadow */
  box-shadow:
    0 12px 28px rgba(0, 0, 0, 0.35),
    0 6px 16px rgba(0, 0, 0, 0.15);

  transform-style: preserve-3d;
  transition: transform 200ms ease, box-shadow 200ms ease;
  cursor: pointer;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* Dark underlay supaya gambar/text hidup */
.card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 50% 60%,
    rgba(0, 0, 0, 0.35),
    rgba(0, 0, 0, 0.18) 45%,
    transparent 90%
  );
  opacity: 0.88;
  pointer-events: none;
}

/* Soft top shine */
.card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.16),
    rgba(255, 255, 255, 0)
  );
  opacity: 0.85;
  pointer-events: none;
}

.card > * {
  position: relative;
  z-index: 2;
}

.product-title {
  color: #ffffff !important;
  font-weight: 700;
  text-shadow: 0 0 4px rgba(0,0,0,0.75);
}

.product-description {
  color: #e9ecff !important;
  text-shadow: 0 0 3px rgba(0,0,0,0.6);
}

.product-label {
  background: rgba(0,0,0,0.45) !important;
  border: 1px solid rgba(255,255,255,0.18);
  color: #ffffff !important;
  padding: 4px 10px;
  border-radius: 10px;
  backdrop-filter: blur(6px);
}

</style>